<template>
  <div id="app">
    <EarlyRetirementCalculator/>
  </div>
</template>

<script>
import EarlyRetirementCalculator from "./components/EarlyRetirementCalculator.vue";

export default {
  name: "app",
  components: {
    EarlyRetirementCalculator
  }
};
</script>

<style>
html,
body {
  height: 100%;
}

body {
  display: -ms-flexbox;
  display: flex;
  -ms-flex-align: center;
  align-items: center;
}

#app {
  width: 100%;
  margin: auto;
}

[v-cloak] {
  display: none;
}
</style>
